import script from "./HeartCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./HeartCenter.vue?vue&type=script&setup=true&lang=js"

import "./HeartCenter.vue?vue&type=style&index=0&id=5ae88c5d&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ae88c5d"]])

export default __exports__